import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import axios from "axios";
import { QueryClient, QueryClientProvider } from "react-query";
import Cookies from "js-cookie";
import AppContext from "./Context/AppContext";
import AdminLayout from "./layout/AdminLayout";

const Login = React.lazy(() => import('./pages/Login/Login'));
const studentLogin = React.lazy(() => import('./pages/StudentLogin/StudentLogin'));
const queryClient = new QueryClient();

// Reusable loading spinner
const loading = (
  <div className="loading">
    <div className="spinner-grow text-success" role="status"></div>
  </div>
);

// PrivateRoute to protect admin paths
const PrivateRoute = ({ loginStatus, children, setLoginStatus }) => {
  return loginStatus ? children : <Login setLoginStatus={setLoginStatus} />;
};

function App() {
  const [loginStatus, setLoginStatus] = useState(() => {
    const savedStatus = sessionStorage.getItem("loginStatus");
    return savedStatus === "true";
  });

  useEffect(() => {
    if (loginStatus) {
      sessionStorage.setItem("loginStatus", "true");
    } else {
      sessionStorage.removeItem("loginStatus");
    }
  }, [loginStatus]);
  // Remove login cookie on tab/window close
  // useEffect(() => {
  //   const handleUnload = () => {
  //     Cookies.remove("loginStatus");
  //   };

  //   window.addEventListener("unload", handleUnload);
  //   return () => {
  //     window.removeEventListener("unload", handleUnload);
  //   };
  // }, []);
  useEffect(() => {
    if (loginStatus) {
      Cookies.set("loginStatus", "true", { expires: 1 });  // 1 day expiry cookie
    } else {
      Cookies.remove("loginStatus");
    }
  }, [loginStatus]);
  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        console.log("IP address:", response?.data?.ip);
      } catch (error) {
        console.error("Error fetching the IP address:", error);
      }
    };
    fetchIpAddress();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AppContext.Provider value={{ loginStatus, setLoginStatus }}>
        <Router>
          <Suspense fallback={loading}>
            <Routes>
              <Route
                path="/"
                element={
                  loginStatus ? (
                    <AdminLayout setLoginStatus={setLoginStatus} />
                  ) : (
                    <Login setLoginStatus={setLoginStatus} loginStatus={loginStatus} />
                  )
                }
              />
              <Route
                path="/*"
                element={
                  <PrivateRoute loginStatus={loginStatus} setLoginStatus={setLoginStatus}>
                    <AdminLayout setLoginStatus={setLoginStatus} />
                  </PrivateRoute>
                }
              />
            </Routes>
          </Suspense>
        </Router>
      </AppContext.Provider>
    </QueryClientProvider>
  );
}

export default App;
